import type { GeoJsonPoint } from '../types';

export default function isGeojsonPoint(geometry: GeoJsonPoint): boolean {
  return geometry &&
    geometry.type === 'Point' &&
    geometry.coordinates &&
    geometry.coordinates.length === 2;
}
